//#region [IMPORT]

import { on, removeListener, sendMessageData } from "api/prokey/prokey.websocket";
import React, { createContext, useEffect, useState } from "react"

//#endregion

const FieldPanelContext = createContext()

//-----------------------------------------------------------------
function FieldPanelProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ doctypes , setDocuments ] = useState( [] );
  const [ pagetypes, setPagetypes ] = useState( [] );

  const values = {
    doctypes ,
    pagetypes,
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
      //-----------------------------------------------------------------
      function handleDoctypes(data) {
        //-----------------------------------------------------------------
        if( data?.documents == undefined ) return;

        setDocuments( data?.documents || [] );

        const docs = [...data.documents];
        docs.push( { label: 'F - Following Page', numcode: 'F', name: 'Following Page'} );
        docs.push( { label: 'B - Blank Page'    , numcode: 'B', name: 'Blank Page'    } );
        setPagetypes( docs );
      }
  
      on( 'DOCUMENT-LIST', handleDoctypes );
      sendMessageData( 'DOCUMENT-LIST-REQUEST' );

    return () => {
      removeListener( 'DOCUMENT-LIST' , handleDoctypes );
    };
  }, [] );

  //#endregion

  return (
    <FieldPanelContext.Provider value={ values }>
      {children}
    </FieldPanelContext.Provider>
  );
};

export { FieldPanelContext, FieldPanelProvider };